import { getContext } from '@/assets/js/mapContext';
import { Overlay } from 'ol';

export default {
  methods: {
    removeOverlays({ id }) {
      const mapOverlays = this.map.getOverlays();
      [...mapOverlays.getArray()].forEach(overlay => {
        if (overlay.getId().startsWith(id)) this.map.removeOverlay(overlay);
      });
    },
    setMapOverlayProperty(id, property, value) {
      const overlay = this.map.getOverlayById(id);
      if (!overlay) return;
      switch (property) {
        case 'position':
          return overlay.setPosition(value);
        default:
          throw new Error(`Property ${property} not recognized`);
      }
    },
    createMapOverlay({ id, overlayProps = {}, body, selector }) {
      let overlay = this.map.getOverlayById(id);
      if (!overlay) {
        let overlayDiv;
        if (selector) overlayDiv = selector;
        else {
          overlayDiv = document.createElement('div');
          overlayDiv.id = id;
          document.body.appendChild(overlayDiv);
        }
        const overlayOl = new Overlay({
          id: id,
          element: overlayDiv,
          ...overlayProps,
        });
        this.map.addOverlay(overlayOl);
      }
      overlay = this.map.getOverlayById(id);
      overlay.setPosition(overlayProps.position);
      const overlayDiv = document.querySelector(`#${id}`);
      if (!selector && body) overlayDiv.innerHTML = body;
      return overlay;
    },
  },
  mounted() {
    getContext(this).$off('removeOverlays');
    getContext(this).$on('removeOverlays', this.removeOverlays);

    getContext(this).$off('createMapOverlay');
    getContext(this).$on('createMapOverlay', this.createMapOverlay);

    getContext(this).$off('setMapOverlayProperty');
    getContext(this).$on('setMapOverlayProperty', this.setMapOverlayProperty);
  },
};
